const { createContext } = require('react');

const StateConfigContext = createContext();
export default StateConfigContext;
